import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProductCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ProductCardLeftContent = styled.div`
  display: flex;
  gap: 16px;
`;

export const ProductCardRightContent = styled.div`
  display: flex;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const ConfirmationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 525px;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ConfirmationModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

export const ConfirmationModalItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PriceChangeInfoContainer = styled.div`
  background: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;
